import serviceAPI from 'services/service_api'

const baseURL = process.env.REACT_APP_API_URL
const authAPI = serviceAPI(baseURL)

export async function signIn(email, password) {
	const { data } = await authAPI.post('/sign-in', { email, password })

	const authData = {
		accessToken: data.AccessToken,
		expiresIn: data.ExpiresIn,
		idToken: data.IdToken,
		refreshToken: data.RefreshToken,
		tokenType: data.TokenType,
	}

	localStorage.setItem('user-contracts', JSON.stringify(authData))

	return authData
}

export async function signOut() {
	// TODO: call logout endpoint to invalidate token when available
	// await authAPI.post('/logout')
	localStorage.clear()
}

export async function signInSSO(email) {
	const { data } = await authAPI.post('/config/retrieve-sso-options', { email })

	return data
}

export async function getTokens(code, companyId) {
	const { data } = await authAPI.post('/auth/get-tokens', { code, companyId })

	return data
}

export async function getUrlSSO(provider) {
	const { data } = await authAPI.get('/auth/get-url-sso', {
		params: { provider },
	})

	return data
}

export async function signUpNewUser(payload) {
	const { data } = await authAPI.post('/create-account', payload)

	return data
}
